export const History = () => {
    return (
        <div>
            <h1 className="text-3xl text-slate-100 font-bold">History</h1>
        </div>
    )
}